export enum ShaderView {
  None = 0,
  BlackAndWhite = 1,
}
